// add the "read more" link to the bottom of tall event portlets
document.addEventListener('DOMContentLoaded', e => {
    setTimeout(() => {
        $('.event').each(function () {
            let event = $(this);
            let heading = event.find('.event-heading');
            let body = event.find('.event-body');

            if ((heading.height() + body.height()) > 600) {
                let tag = $('<div>')
                    .addClass('read-more-footer rounded-bottom')
                    .append(
                        $('<a>')
                            .attr('href', '#')
                            .attr('data-toggle', 'modal')
                            .attr('data-target', `#event-modal`)
                            .text('Read More')
                    );
                event.append(tag);
            }
        });
    }, 1000);
});

$('#event-modal').on('show.bs.modal', function (e) {
    let modal = $(this);
    let button = $(e.relatedTarget);
    let event = button.closest('.event');

    let title = event.find('.figure-caption').text();
    modal.find('.event-modal-title').text(title);

    let description = event.find('.event-description').html().trim();
    modal.find('.event-modal-description').html(description);
});
